import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

// Public config — these are not secrets. Safe to commit.
// Same project as the mobile app (parkproof-app).
const firebaseConfig = {
  apiKey: 'AIzaSyAjhwtqbYihQTZ55iAYa-UfWaL5c0_h5TU',
  authDomain: 'parkproof-app.firebaseapp.com',
  projectId: 'parkproof-app',
  storageBucket: 'parkproof-app.firebasestorage.app',
  messagingSenderId: '787856339602',
  appId: '1:787856339602:web:6f35f2a5f96e079a526c4b',
  measurementId: 'G-T0LCL6DHZR',
};

export const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);
// Cloud Functions deployed in europe-west1 (closest to CH users + OSM mirrors).
export const functions = getFunctions(firebaseApp, 'europe-west1');
